// ToggleSwitch.jsx
import React from "react";

import styled from "styled-components";

const SwitchContainer = styled.div`
    display: inline-flex;
    background-color: var(--color-BaseBlue);
    border-radius: 999px;
    padding: 4px;
`;

const Option = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== "active",
})`
    padding: 0px 4px;
    border-radius: 999px;
    background-color: ${({ active }) => (active ? "#ffffff" : "transparent")};
    color: ${({ active }) => (active ? "#000000" : "#777777")};
    font-weight: 400;
    font-size: 1.2rem;
    cursor: pointer;
    user-select: none;
    transition: background-color 0.2s, color 0.2s;

    &:hover {
        background-color: ${({ active }) => (active ? "#ffffff" : "rgba(0,0,0,0.05)")};
    }
`;
function ToggleSwitch(props) {
    const { options, value, onChange } = props;

    return (
        <SwitchContainer>
            {options.map((opt) => (
                <Option key={opt.value} active={opt.value === value} onClick={() => onChange(opt.value)}>
                    {opt.label}
                </Option>
            ))}
        </SwitchContainer>
    );
}

export default ToggleSwitch;
